<template>
  <div class="wx-open-message-configure-pub-detail">
    <slot :show="handleShow"></slot>
    <DataGridDialog :visible.sync="visible"
                    custom-class="wx-open-message-configure-pub-detail-dialog"
                    title="模板详情"
                    width="640px"
                    @open.once="loadKeywords">
      <div class="detail-wrap"
           v-loading="loading"
           element-loading-text="数据加载中，请稍等...">
        <template v-if="keywords">
          <AppScrollbar style="height: 100%">
            <div class="detail-main">
              <el-form size="mini"
                       label-width="100px"
                       label-suffix="：">
                <el-form-item label="模板标题ID">{{item.tid}}</el-form-item>
                <el-form-item label="模板标题">{{item.title}}</el-form-item>
              </el-form>
              <div v-if="keywords.length"
                   class="data-list">
                <DataGrid size="mini"
                          highlight-current-row
                          highlight-hover-row
                          :data="keywords">
                  <DataGridColumn title="关键词ID"
                                  field="kid"
                                  min-width="100"
                                  align="center"></DataGridColumn>
                  <DataGridColumn title="关键词"
                                  field="name"
                                  min-width="120"
                                  align="center"></DataGridColumn>
                  <DataGridColumn title="参数类型"
                                  field="rule"
                                  min-width="100"
                                  align="center"></DataGridColumn>
                  <DataGridColumn title="示例"
                                  field="example"
                                  min-width="200"></DataGridColumn>
                </DataGrid>
              </div>
            </div>
          </AppScrollbar>
        </template>
        <template v-else>
          <Hint v-if="!loading"
                type="error">
            <div>关键字数据加载失败</div>
            <el-button type="text"
                       @click="loadKeywords">重新加载</el-button>
          </Hint>
        </template>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../../../../../elements/grid/DataGridDialog'
import AppScrollbar from '../../../../../../../../elements/AppScrollbar'
import DataGrid from '../../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../../elements/DataGridColumn'
import Hint from '../../../../../../../../elements/Hint'
export default {
  name: 'WxOpenMessageConfigurePubDetail',
  components: {
    DataGridDialog,
    AppScrollbar,
    DataGrid,
    DataGridColumn,
    Hint
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      keywords: null
    }
  },
  methods: {
    handleShow () {
      this.visible = true
    },
    loadKeywords () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/message/wx/open/keywords',
        method: 'post',
        data: this.$qs.stringify({
          tid: this.item.tid
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.keywords = response.data['keywords'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
  .wx-open-message-configure-pub-detail {
    display: inline-block;
  }
  .wx-open-message-configure-pub-detail-dialog {
    .detail-wrap {
      height: 540px;
      .detail-main {
        padding: 15px;
        .el-form {
          .el-form-item {
            margin-bottom: 5px;
            .el-form-item__label {
              color: #909399;
              font-size: 12px;
              text-align: left;
            }
            .el-form-item__content {
              font-size: 12px;
            }
          }
        }
        .data-list {
          margin-top: 5px;
        }
      }
    }
  }
</style>
